import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";

import { Authenticator } from "./Stores/auth";
import LoginScreen from "./Screens/Login/login";
import { observer } from "mobx-react";
import PortalScreen from "./Screens/Portal/portal";
import { app as MainApp } from "./firebase";

export const app = MainApp;

export const authStore = new Authenticator();

function Init() {
  if (!authStore.loaded) {
    return <>loading</>;
  }

  if (!authStore.isSignedIn()) {
    return <LoginScreen />;
  }

  return <PortalScreen />;
}

const App = observer(Init);

export default App;
